import state from "js/state/main"

export default () => {
    state.AJAX_REQUEST_CACHE = {}
}
